import { render, staticRenderFns } from "./InterestPlaces.vue?vue&type=template&id=bd0012e8"
import script from "./InterestPlaces.vue?vue&type=script&lang=js"
export * from "./InterestPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports